import { AppGlobalState } from 'modules/types'

const props = (state: AppGlobalState) => state.modal

export default {
  props,
} as const
